/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import {} from 'mapbox-gl-leaflet';
import 'leaflet-fullscreen';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import drawLocales from 'leaflet-draw-locales';
import 'leaflet.gridlayer.googlemutant';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet.markercluster/dist/leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import { CUSTOM_MAP, custom_map_max_zoom_level, get_custom_map_url, MAP_BOX } from '../../../constants/mapSettings';
import iconAsset from '../../../icons/workOrder.svg';

const language = localStorage.getItem('lang') ||'en';
drawLocales(language !== 'az' ? language : 'en');

class Map extends Component {
  markers = L.markerClusterGroup({
    spiderfyOnMaxZoom: true,
    showCoverageOnHover: false,
    zoomToBoundsOnClick: true,
    spiderfyDistanceMultiplier: 1,
    maxClusterRadius: 50
  });

  constructor(props) {
    super(props);
    this.state = {
      zoomLevel: localStorage.getItem('workorderZoom')
    };
  }

  componentDidMount() {
    this.initializeMap();
  }

  componentDidUpdate(prevProps) {
    const { defaultLocation } = this.props;
    if (prevProps.defaultLocation !== defaultLocation) {
      if (this.initializeMap) {
        this.map.remove();
        this.initializeMap();
      }
    }
  }

  initializeMap = () => {
    const { defaultLocation, user } = this.props;
    const { zoomLevel } = this.state;
    const mapZoomLevel = zoomLevel !== null ? zoomLevel : 15;
    this.map = L.map(`map_${this.props.id}`, {
      attributionControl: false,
      center: [...[defaultLocation[1], defaultLocation[0]]],
      zoom: mapZoomLevel,
      fullscreenControl: true
    });

    if (user && user.portal_airport && user.portal_airport.airport_settings.map_style === MAP_BOX) {
      L.mapboxGL({
        accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
        style: `${user.airport_configuration.mapbox_style ? user.airport_configuration.mapbox_style : 'mapbox://styles/mapbox/satellite-v9'}`
      }).addTo(this.map);
      // eslint-disable-next-line no-underscore-dangle
      this.map._layersMaxZoom = 19;
    } else if (user?.portal_airport?.airport_settings?.map_style === CUSTOM_MAP) {
      L.tileLayer(get_custom_map_url(user?.portal_airport?.airport_settings?.custom_map_url), {
        maxZoom: custom_map_max_zoom_level
      }).addTo(this.map);
    } else {
      L.gridLayer.googleMutant({ type: 'satellite', maxZoom: 20 }).addTo(this.map);
    }
    // eslint-disable-next-line new-cap
    const marker = new L.marker([defaultLocation[1], defaultLocation[0]], {
      draggable: false,
      icon: new L.Icon({
        iconUrl: iconAsset,
        iconSize: [29, 35],
        iconAnchor: [15, 35]
      })
    });
    this.map.addLayer(marker);
  }

  handleZoomLevel = (zoomLevel) => {
    const { setZoomLevel } = this.props;
    setZoomLevel(zoomLevel);
  }

  render() {
    return (
      <>
        <div id={`map_${this.props.id}`} style={{
          zIndex: 0, width: '100%', height: '100%'
        }}
        />
      </>
    );
  }
}

Map.propTypes = {
  defaultLocation: PropTypes.arrayOf(PropTypes.number)
};

Map.defaultProps = {
  defaultLocation: [0, 0]
};
const mapStateToProps = state => ({
  user: state.auth.profile
});

export default connect(mapStateToProps, {})(Map);
